import { CustomerRatingsAndReviewsPageSearchParams } from '../../types';

export type GetCustomerRatingsAndReviewPageFilterProps = {
  tag?: string | string[];
  rating?: string;
};

export type GetCustomerRatingsAndReviewPageUrlProps = {
  articleId: string;
  searchParams?: URLSearchParams | null;
  variationId?: string;
  page?: string;
  filterBy?: GetCustomerRatingsAndReviewPageFilterProps;
};

/* 
    getCustomerRatingsAndReviewsPageUrl
    a method to get a valid customer ratings and reviews page URLSearchParams
    you can pass all needed parts by PageProps

    @params productId - the productId of the product (akl or slug param -> RSC by params and RCC by useParams hook)
    @params filterBy.tag - the tag to filter the ratings (ftag param -> RSC by params and RCC by useParams hook)
    @params filterBy.rating - a comma separated string of rating values to filter the ratings (will be added to the URL search params)
    @params searchParams - the URLSearchparams  (RSC by searchParams and getURLSearchParamsFromPagePropsSearchParams helper function and RCC by useSearchParams hook)
    @params variationId - the variationId of the product (currently the sku -> will be added to the URL search params)
    @params page - the page of the rating page (will be added to the URL search params)
  */
export const getCustomerRatingsAndReviewsPageUrl = ({
  articleId,
  filterBy,
  searchParams,
  variationId,
  page,
}: GetCustomerRatingsAndReviewPageUrlProps) => {
  const newSearchParams = new URLSearchParams(searchParams || undefined);
  if (variationId) {
    newSearchParams.set(CustomerRatingsAndReviewsPageSearchParams.VARIATION_ID, variationId);
  }
  if (page) {
    newSearchParams.set(CustomerRatingsAndReviewsPageSearchParams.PAGE, page);
  }
  if (filterBy?.rating !== undefined) {
    if (filterBy.rating.length === 0) {
      newSearchParams.delete(CustomerRatingsAndReviewsPageSearchParams.FILTER_BY_RATING);
    } else {
      newSearchParams.set(
        CustomerRatingsAndReviewsPageSearchParams.FILTER_BY_RATING,
        filterBy.rating,
      );
    }
  }
  return `/p/${articleId}/rating${filterBy?.tag ? `/${Array.isArray(filterBy.tag) ? filterBy.tag[0] : filterBy.tag}` : ''}${newSearchParams.size ? `?${newSearchParams}` : ''}`;
};
